import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propBool, propStr } from '@/helpers/custom-prop-types';
import { rfpOrderValidate } from '@/validate/custom/rfp/client/order';
import OrderInputRadio from './OrderInputRadio';
import OrderInputRow from './OrderInputRow';
/**
 * TODO: TS化 & tailwind化
 */
const OrderOtherRow = (props) => {
    const { checked, label, radioName, radioValue } = props;
    return (_jsxs("div", Object.assign({ className: 'input_contents_row input_contents_others_row' }, { children: [_jsx("div", Object.assign({ className: 'input_contents_row_head field' }, { children: _jsx(Field, { checked: checked, component: OrderInputRadio, name: radioName, rightComponent: _jsx("div", Object.assign({ className: 'other_label' }, { children: label })), setValue: radioValue, validate: rfpOrderValidate.select }) })), _jsx(OrderInputRow, { checked: checked, identifier: radioValue, placeholder: 'よろしければ、ご決定の理由を教えてください', showDates: false })] })));
};
OrderOtherRow.propTypes = {
    checked: propBool().isRequired,
    label: propStr().isRequired,
    radioName: propStr().isRequired,
    radioValue: propStr().isRequired,
};
export default OrderOtherRow;
